<template>
  <header class="simple-nav">
    <div class="simple-nav__main-navigation" @click="$store.dispatch('nav/setAdditionalNav', '')">
      <NavLogo :homepageUrl="homepageUrl" variant="mobile"></NavLogo>
      <AdditionalMainLinks
        :links="additionalMainLinksReduced"
        class="simple-nav__additional-main-links"
      ></AdditionalMainLinks>
    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import NavLogo from '@/components/Navigation/NavLogo/NavLogo.vue'
import AdditionalMainLinks from '@/components/Navigation/AdditionalMainLinks/AdditionalMainLinks.vue'

const ADDITIONAL_MAIN_LINK_IDS = ['mini-cart']

export default {
  name: 'CheckoutNav',
  components: {
    NavLogo,
    AdditionalMainLinks,
  },

  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      homepageUrl: 'page/homepageUrl',
      additionalMainLinks: 'nav/additionalMainLinks',
    }),

    additionalMainLinksReduced() {
      return this.additionalMainLinks.filter(({ id }) => ADDITIONAL_MAIN_LINK_IDS.includes(id))
    },
  },

  mounted() {
    const navdata = Object.values(window.NAVIGATION_DATA)[0]

    // Update state with asynchronous data
    Object.keys(navdata.desktop).forEach(element => {
      this.$store.dispatch('nav/updateState', {
        key: element,
        value: navdata.desktop[element],
      })
    })

    this.$store.commit('nav/unblockDropdownNav')
  },
}
</script>

<style scoped lang="scss">
.simple-nav {
  z-index: 3;
  position: relative;
  height: $header-height;

  &__main-navigation {
    display: block;
    height: $header-height;
    position: relative;
    z-index: $navigation-z-index - 1;
    border-bottom: 1px solid $color-navigation-border;
    background-color: $color-white;
  }

  &__additional-main-links /deep/ .additional-main-links__link {
    padding-top: 19px;
  }

  &__additional-main-links /deep/ .additional-main-links__cart-items {
    top: 14px;
    left: $navigation-first-link-padding-left + 8px;

    @media ($mq-full) {
      left: $navigation-first-link-padding-left-full + 13px;
    }
  }
}
</style>
